import ReleaseLyrics from '../components/Release/Lyrics/Index'
import ReleaseLyricsSimpleForm from '../components/Release/Lyrics/SimpleForm'
import ReleaseLyricsSyncForm from '../components/Release/Lyrics/SyncForm'

export default [
  // マイリリース
  {
    path: '/client/release-single/step2/lyrics/:discIndex/:trackIndex',
    name: 'release-single-step2-lyrics',
    component: ReleaseLyrics,
    meta: {
      sideMenuId: 'release-single',
    },
  },
  {
    path: '/client/release-single/step2/lyrics/:discIndex/:trackIndex/simple',
    name: 'release-single-step2-lyrics-simple',
    component: ReleaseLyricsSimpleForm,
    meta: {
      sideMenuId: 'release-single',
    },
  },
  {
    path: '/client/release-single/step2/lyrics/:discIndex/:trackIndex/sync',
    name: 'release-single-step2-lyrics-sync',
    component: ReleaseLyricsSyncForm,
    meta: {
      sideMenuId: 'release-single',
    },
  },
  // アルバム遷移
  {
    path: '/client/release-album/step2/lyrics/:discIndex/:trackIndex',
    name: 'release-album-step2-lyrics',
    component: ReleaseLyrics,
    meta: {
      sideMenuId: 'release-album',
    },
  },
  {
    path: '/client/release-album/step2/lyrics/:discIndex/:trackIndex/simple',
    name: 'release-album-step2-lyrics-simple',
    component: ReleaseLyricsSimpleForm,
    meta: {
      sideMenuId: 'release-album',
    },
  },
  {
    path: '/client/release-album/step2/lyrics/:discIndex/:trackIndex/sync',
    name: 'release-album-step2-lyrics-sync',
    component: ReleaseLyricsSyncForm,
    meta: {
      sideMenuId: 'release-album',
    },
  },
]
